/**
 * Assistant status endpoint (docs/agent.md §5).
 *
 * The UI gates on THIS, not on `user.is_staff` alone: the feature is only really
 * available when the kill switch is on AND the upstream is configured AND the
 * user is staff, and only the server knows all three. A `{enabled: false}` reply
 * is deliberately detail-free, so a non-staff collaborator learns nothing about
 * the provider, the model, or anyone's usage.
 */
export interface AgentStatusResponse {
  enabled: boolean;
  model?: string;
  usage?: { promptTokens: number; completionTokens: number; requests: number };
  budget?: { dailyTokens: number };
  remaining?: number;
}

const DISABLED: AgentStatusResponse = { enabled: false };

export async function fetchAgentStatus(): Promise<AgentStatusResponse> {
  try {
    const res = await fetch('/api/agent/status', { credentials: 'include' });
    if (!res.ok) return DISABLED;
    const data = (await res.json()) as AgentStatusResponse;
    return typeof data?.enabled === 'boolean' ? data : DISABLED;
  } catch {
    // Backend down or offline: the assistant is simply not available. This is
    // not an error state worth surfacing — the rest of the editor works.
    return DISABLED;
  }
}
